<template>
  <artmisads-modal :open="true" title="Payment Details" :width="1200" :onCancel="() => props.setDetailData({})"
    :destroyOnClose="true" :footer="null">
    <a-spin :spinning="spinning">
      <div class="payment">
        <div class="info">
          <div class="head">
            <p>Payment Info</p>
            <div class="head-btn">
              <artmisads-select-button @click="toInvoicePdf" v-if="props.detailData.amount > 0 || props.detailData.billingType === 'MONTHLY'">
                <svg class="icon icon-daochu1" aria-hidden="true">
                  <use xlink:href="#icon-daochu1"></use>
                </svg>
                Download Invoice
              </artmisads-select-button>
              <artmisads-button-special @click="financeSellerBillingsDetailExport">
                <svg class="icon daochu" aria-hidden="true">
                  <use xlink:href="#icon-daochu"></use>
                </svg>
                <span class="btn-text">Export</span>
              </artmisads-button-special>
            </div>
          </div>
          <div class="tag">
            <div class="item date">
              <span class="line"></span>
              <div class="text">
                <span class="name">Billing Date:</span>
                <span
                  class="num">{{ moment(props.detailData.billingDateTimestamp).tz(AMAZON_COUNTRY_TIME_TZ[props.detailData.marketplace]).format('YYYY-MM') }}</span>
              </div>
            </div>
            <div class="item payment-id">
              <span class="line"></span>
              <div class="text">
                <span class="name">Payment ID:</span>
                <span class="num">{{ props.detailData.billingId }}</span>
              </div>
            </div>
            <div class="item type">
              <span class="line"></span>
              <div class="text">
                <span class="name">Payment Type:</span>
                <span class="num">{{ setBillingType(props.detailData.billingType) }}</span>
              </div>
            </div>
            <div class="item amount">
              <span class="line"></span>
              <div class="text">
                <span class="name">Payment Amount:</span>
                <span class="num">
                  {{ AMAZON_CURRENCY_MAPPER[props.detailData.marketplace] }}{{ props.detailData.amount }}</span>
              </div>
            </div>
            <div class="item marketplace">
              <span class="line"></span>
              <div class="text">
                <span class="name">Marketplace:</span>
                <div class="marketplace-tag">
                  <div>
                    <Icon :name="COUNTRY_BASE_MAP[props.detailData.marketplace].icon"></Icon>
                    <span>{{ props.detailData.marketplace }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="item status">
              <span class="line"></span>
              <div class="text">
                <span class="name">Status:</span>
                <div v-if="props.detailData.billingType === 'MONTHLY'">
                  <financeStatus :type="lowercaseFirst(props.detailData?.status)" />
                </div>
                <div v-else>
                  <financeStatus :pageType="lowercaseFirst(props.detailData?.status)" :pageTypeClass="lowercaseFirst(props.detailData?.status)" />
                </div>
              </div>
            </div>
            <div class="item due-date">
              <span class="line"></span>
              <div class="text">
                <span class="name">Due Date:</span>
                <span class="num">{{ props.detailData.dueDate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="detail">
          <p>Details</p>
          <div class="filter">
            <div class="button-groups">
              <buttonGroups :pagination="{
                total: listTotal,
                current: params.page,
                size: params.size,
              }" :tableData="list" @pageChange="onPageChange" />
              <artmisads-segmented-tabs style="margin: 0 0 0 10px;" v-model="activeTab" :items="programConfig" />
            </div>
            <div class="search">
                 <artmisads-select-button class="download" @click="downloadReport" v-if="props.detailData.billingType === 'MONTHLY'">
            <svg class="icon icon-daochu1" aria-hidden="true" style="margin-right: 8px;">
              <use xlink:href="#icon-daochu1"></use>
            </svg>
            Download Report
          </artmisads-select-button>
              <a-input-search v-model:value="params.keyword" placeholder="search..."
                @search="getFinanceSellerBillingsDetail" allowClear="true" />
            </div>
          </div>
          <div class="table">
            <a-table
            :bordered="true"
            :columns="columns" row-key="id" :data-source="list" :pagination="{
              total: listTotal,
              current: params.page,
              pageSize: params.size,
              showSizeChanger: true
            }" 
              @change="onChangePage" tableLayout="fixed">
              <template #bodyCell="{ column, record, text }">
                <template v-if="column.name === 'showCurrency'">
                  {{ text||text==0? AMAZON_CURRENCY_MAPPER[record.marketplace] :'--'}}{{ text }}
                </template>
                <template v-if="column.name === 'amount'">
                  <div :class="text? text > 0 ? 'amount-plus' : 'amount-minus':''">
                    {{ setUnit(text) }} {{text||text==0? AMAZON_CURRENCY_MAPPER[record.marketplace] :''}}{{ setAmount(text) }}
                  </div>
                 
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </a-spin>
  </artmisads-modal>
</template>

<script setup>
import { useRouter } from "vue-router"
import moment from 'moment'
import { keyBy } from 'lodash'
import Icon from '~/components/Icon.vue'
import financeStatus from '~/components/financeStatus'
import { message, Modal } from "ant-design-vue"
import { AMAZON_CURRENCY_MAPPER, AMAZON_COUNTRY_TIME_TZ } from '~/contants/common'
import { ref, onBeforeMount, computed, onMounted, watch } from "vue"
import ButtonGroups from '~/pages/seller/Brands/components/buttonGroups.vue'
import { financeApi } from "~/server/operator/finance";
import { COUNTRY_BASE } from "~/contants/common"
import { useSystemStore } from '@/storeData/system'
import {lowercaseFirst} from '~/utils/index.js'
const systemStore = useSystemStore()
const programConfig = computed(() => systemStore.programConfig)
const COUNTRY_BASE_MAP = keyBy(COUNTRY_BASE, 'host')
const router = useRouter()
const props = defineProps(["detailData", 'setDetailData', 'hasCompleteInfo', 'setShowNotice'])
const list = ref([])
const listTotal = ref(0)
const spinning = ref(false)
const activeTab = ref('0')
const billingBusinessSourceData = ref([
  'amazon_attribution',
  'amazon_associate',
  'amazon_creator_connection',
])
const params = ref({
  page: 1,
  size: 10,
  keyword: null,
})
const columns = ref([
  {
    title: 'Amazon Seller',
    dataIndex: 'sellerName',
    
  },
  {
    title: 'Brand',
    dataIndex: 'brandName',
   
  },
  {
    title: 'Publisher Name',
    dataIndex: 'publisherName',
   
  },
  {
    title: 'Sales for Commissions',
    dataIndex: 'saleCommissionAmount',
   
    name: 'showCurrency',
  },
  {
    title: 'Commissions',
    dataIndex: 'amount',
    
    name: 'showCurrency',
  },
  {
    title: 'Media Commission',
    dataIndex: 'commissionAmount',
  
    name: 'showCurrency',
  },
  {
    title: 'Platform Commission',
    dataIndex: 'platformFeeAmount',
   
    name: 'showCurrency',
  },
])
const setColumns = () => {
  if (activeTab.value === '0') {
    if (props.detailData.billingType === 'MONTHLY') {
      columns.value = [
        {
          title: 'Amazon Seller',
          dataIndex: 'sellerName',
       
        },
        {
          title: 'Brand',
          dataIndex: 'brandName',
         
        },
        {
          title: 'Publisher Name',
          dataIndex: 'publisherName',
         
        },
        {
          title: 'Sales for Commissions',
          dataIndex: 'saleCommissionAmount',
         
          name: 'showCurrency',
        },
        {
          title: 'Commissions',
          dataIndex: 'amount',
         
          name: 'showCurrency',
        },
        {
          title: 'Media Commission',
          dataIndex: 'commissionAmount',
         
          name: 'showCurrency',
        },
        {
          title: 'Platform Commission',
          dataIndex: 'platformFeeAmount',
         
          name: 'showCurrency',
        },
      ]
    } else {
      columns.value = [
        {
          title: 'Amazon Seller',
          dataIndex: 'sellerName',
         
        },
        {
          title: 'Brand',
          dataIndex: 'brandName',
          
        },
        {
          title: 'Publisher Name',
          dataIndex: 'publisherName',
          
        },
        {
          title: 'Sales for Commissions',
          children: [
            {
              title: 'Original',
              dataIndex: 'previousSalesAmount',
              key: 'previousSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalSalesAmount',
              key: 'finalSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'saleCommissionAmount',
              key: 'saleCommissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Commissions',
          children: [
            {
              title: 'Original',
              dataIndex: 'previousAmount',
              key: 'previousAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalAmount',
              key: 'finalAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'amount',
              key: 'amount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Media Commissions',
          children: [
            {
              title: 'Original',
              dataIndex: 'previousCommissionAmount',
              key: 'finalCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalCommissionAmount',
              key: 'finalCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'commissionAmount',
              key: 'commissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Platform Commissions',
          children: [
            {
              title: 'Original',
              dataIndex: 'previousPlatformFeeAmount',
              key: 'previousPlatformFeeAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalPlatformFeeAmount',
              key: 'finalPlatformFeeAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'platformFeeAmount',
              key: 'platformFeeAmount',
              name: 'amount',
            }
          ],
        }
      ]
    }
  }else{
    columns.value =   [
    {
      title: 'Amazon Seller',
      dataIndex: 'sellerName',
      
    },
    {
      title: 'Brand',
      dataIndex: 'brandName',
     
    },
    {
      title: 'Publisher Name',
      dataIndex: 'publisherName',
      
    },
    {
      title: 'Sales for Commissions',
      dataIndex: 'saleCommissionAmount',
      
      name: 'showCurrency',
    },
    {
      title: 'Commissions',
      dataIndex: 'amount',
      
      name: 'showCurrency',
    },
    {
      title: 'Media Commission',
      dataIndex: 'commissionAmount',
    
      name: 'showCurrency',
    },
    {
      title: 'Platform Commission',
      dataIndex: 'platformFeeAmount',
     
      name: 'showCurrency',
    },
  ]
  }
}
watch(() => props.detailData.billingType, () => {

  setColumns()
}, { immediate: true, deep: true })
const downloadReport=()=>{
   const finalParams = {
    qs: {
      billingId: props.detailData.billingId, keyword: params.value.keyword || '',
      billingBusinessSource: billingBusinessSourceData.value[Number(activeTab.value)]
    },
    platform: 'operator',
    fileName: `payment-${activeTab.value == '0' ? 'attribution' : 'associate'}-detail-${moment().format('YYYY-MM-DD')}.csv`,
  }
  
  financeApi.financeSellerBillingsReportExport(finalParams)
}
const setBillingType = (value) => {
  if (value === undefined || value === null) return ''
  const str = String(value).toLowerCase()
  return str.charAt(0).toUpperCase() + str.slice(1)
}
const toInvoicePdf = () => {
    const { href } = router.resolve({ path: `/operator/invoice-pdf/${props.detailData.billingId}` })
    window.open(href, '_blank')
 
}

const onChangePage = (data, filters) => {
  const { current, pageSize } = data
  params.value.page = current
  params.value.size = pageSize
  getFinanceSellerBillingsDetail()
}
const setUnit = (record) => {
  if(record||record==0){
  if (record > 0) {
    return '+'
  }
  else if(record == 0){
    return ''
  }
  else {
    return '-'
  }
}
  else{
    return ''
  }
}
const setAmount = (record) => {
  if(record||record==0){
  return Math.abs(record)
  }
  else{
    return '--'
  }
}
watch(() => activeTab.value, () => {
  params.value.page = 1
  params.value.size = 10
  params.value.keyword = null
  getFinanceSellerBillingsDetail()
  setColumns()
})
const getFinanceSellerBillingsDetail = async () => {
  spinning.value = true
  const billingBusinessSource = billingBusinessSourceData.value[Number(activeTab.value)]
  // Payment Details  props.detailData.billingId
  const paramsData = { ...params.value, billingId: props.detailData.billingId, keyword: params.value.keyword, billingBusinessSource }
  const res = await financeApi.getFinanceSellerBillingsDetailsBillingIdItems(paramsData)
   const { data, total } = res;
  if (res) {
    listTotal.value = total;
    list.value = data;
  }
  spinning.value = false
}

const onPageChange = current => {
  params.value.page = current
  getFinanceSellerBillingsDetail()
}

const financeSellerBillingsDetailExport = () => {
  const finalParams = {
    qs: {
      billingId: props.detailData.billingId, keyword: params.value.keyword || '',
      billingBusinessSource: billingBusinessSourceData.value[Number(activeTab.value)]
    },
     platform: 'operator',
    fileName: `payment-${activeTab.value == '0' ? 'attribution' : 'associate'}-detail-${moment().format('YYYY-MM-DD')}.csv`,
  }
  financeApi.exportSellerPaymentConfirmDetail(finalParams)
}

onBeforeMount(() => {
  getFinanceSellerBillingsDetail()
})
</script>

<style lang="less" scoped>
.search{
  display: flex;
  align-items: center;
  gap: 12px;
}
.amount-plus{
  color: #FF0000;
}
.amount-minus{
  color: #2AAE67;
}
.payment {
  .info {
    margin-top: 6px;

    .head {
      display: flex;
      justify-content: space-between;

      >p {
        font-weight: 600;
        font-size: 20px;
        color: var(--dark-1);
        letter-spacing: 0.5px;
        line-height: 28px;
      }

      .head-btn {
        display: flex;

        button:first-child {
          display: flex;

          svg {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            align-self: center;
          }
        }

        button:last-child {
          cursor: pointer;
          display: flex;
          margin-left: 16px;

          .jiantou {
            width: 16px;
            height: 16px;
            fill: var(--dark-3);
            margin-left: 8px;
          }

          .daochu {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            fill: var(--dark-1);
          }

          >svg {
            align-self: center;
          }

          >span {
            align-self: center;
          }

          .btn-text {
            align-self: center;
            font-weight: 500;
            line-height: 20px;
            margin-right: 8px;
          }
        }
      }

    }
  }

  .tag {
    display: flex;
    padding: 11px 0 11px 16px;
    background-color: var(--bg-gray-1);
    border-radius: 8px;
    margin-top: 16px;

    .item {
      display: flex;
      width: 200px;

      .line {
        width: 3px;
        height: 40px;
        opacity: 0.85;
        border-radius: 2px;
      }

      .text {
        display: flex;
        flex-direction: column;
        margin-left: 11px;

        .name {
          font-weight: 400;
          font-size: 13px;
          color: var(--dark-2);
          letter-spacing: 0.3px;
          line-height: 18px;
          margin-bottom: 4px;
        }

        .num {
          color: var(--dark-1);
          font-weight: 600;
          font-size: 14px;
          letter-spacing: 0.4px;
          line-height: 20px;
        }
      }
    }

    .due-date {
      .line {
        background-color: var(--tag-bg-5);
      }
    }

    .date {
      .line {
        background-color: var(--tag-bg-1);
      }
    }

    .type {
      .line {
        background-color: #2AAE67;
      }
    }

    .amount {
      .line {
        background-color: var(--tag-bg-3);
      }
    }

    .marketplace {
      .marketplace-tag {
        display: inline-block;

        >div {
          display: flex;
          background-color: var(--bg-gray-8);
          border-radius: 4px;
          padding: 0 6px;
          line-height: 20px;

          >svg {
            width: 20px;
            height: 20px;
            margin-right: 4px;
            align-self: center;
          }
        }
      }

      .line {
        background-color: var(--tag-bg-7);
      }
    }

    .payment-id {
      width: 280px;

      .line {
        background-color: var(--tag-bg-2);
      }
    }

    .status {
      width: 160px;

      .line {
        background-color: var(--tag-bg-9);
      }
    }
  }

  .detail {
    >p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-top: 32px;
      margin-bottom: 16px;
    }

    .filter {
      display: flex;
      justify-content: space-between;

      .button-groups {
        display: flex;
        align-items: center;
      }
    }

    .table {
      margin-top: 16px;
    }
  }

}
</style>
